module.exports = __webpack_public_path__ + "img/sx2.38327e27.png";